export const consultoriasGestoresMenu = {
    name: 'Consultorias',
    url: '/appsebrae/consultorias/gestores/consultorias',
    icon: 'fa fa-book',
    regras: ['APPSE-GEST-CONS-00'],
    badge: {
        variant: 'primary',
        text: 'GESTOR'
    }
}
